@let from = range()?.from;
@let to = range()?.to;

@if (from && to) {
  <span>{{ from | onyxDate: 'date-dot' : { endDate: to } }}</span>
} @else {
  -
}
